var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-banner",on:{"click":function($event){return _vm.$router.push('/pricing');}}},[_c('span',{staticClass:"icon",staticStyle:{"margin-top":"15px","margin-left":"15px"}},[_vm._v("🎉")]),_c('span',{staticClass:"banner-text-feature"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }